import { useState } from "react";
import { useLocation } from "react-router-dom";
import { canAccessPage } from "../../constants/Roles";
import { getCurrentRole } from "../../utils/roleUtils";

export const sidebarData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    iconName: "dashboard",
    page: "dashboard",
  },
  {
    title: "Create New",
    path: "/create-new",
    iconName: "createNew",
    page: "create-new",
  },
  { title: "All List", path: "/all-list", iconName: "list", page: "all-list" },
  {
    title: "Company & Distributor",
    path: "/Company-and-distributor",
    iconName: "groupIcon",
    page: "parent-code",
  },
];

// Returns only sidebar items the current role can access
export const useAllowedSidebarItems = () => {
  const role = getCurrentRole();
  return sidebarData.filter((item) => canAccessPage(role, item.page));
};

export const handleLogout = (navigate, toastService) => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    toastService.success("Log out successfully!");
    setTimeout(() => {
      navigate("/");
    }, 500);
  } catch (error) {
    toastService.error("Logout failed. Please try again.");
  }
};

export const useSidebarData = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  const toggleDropdown = (index) =>
    setOpenDropdown(openDropdown === index ? null : index);
  const isActive = (path) => location.pathname === path;
  const hasActiveSubmenu = (subMenu) =>
    subMenu?.some((item) => location.pathname === item.path);

  return {
    toggleDropdown,
    isOpen,
    openDropdown,
    isActive,
    hasActiveSubmenu,
    setIsOpen,
  };
};
